/**
 * @module views\sys\test
 */
import { Watch, Prop, Mixins, Component } from "vue-property-decorator";
import ghBase from "@/components/ghBase";
import LevelNavigation from "@/businessComponents/mdl/levelNavigation/levelNavigation";
import go, { Binding } from "gojs";
import GhDiagram from "@/components/ghDiagram/ghDiagram";
import { CreateElement } from "vue";
import { MethodService } from "../../../utils/serviceModel";
import Vue from "vue";
import parseCode from "@/utils/dynamic";

const make = go.GraphObject.make;

// const GhBase=()=>import()

const getCode: MethodService = new MethodService(
  "mes.business.sys.service",
  "SourceService",
  "get_code"
);
// const test=Vue.component(

@Component({
  components: {
    LevelNavigation,
    myTest: parseCode("5cbd7d48d2a0eb3c34599fa6")
  }
})
export default class Test extends ghBase {
  private model: go.TreeModel | null = null;

  private data: any[] = [];

  private level = 3;

  private range: IRange = {
    lower: -3,
    upper: 3,
    includeLower: true
  };

  private get diagram() {
    if (this.ghDiagram) {
      return this.ghDiagram.Diagram;
    }
  }

  private get ghDiagram() {
    return this.$refs.diagram as GhDiagram;
  }

  mounted() {
    if (this.diagram) {
      this.diagram.initialViewportSpot = go.Spot.TopCenter;
      this.diagram.initialDocumentSpot = go.Spot.TopCenter;

      this.diagram.layout = this.ghDiagram.treeVerticalLayout;
      this.diagram.linkTemplate = this.ghDiagram.treeLinkTemplate;
      let pannel = make(go.Panel, go.Panel.Auto, {});
      this.diagram.nodeTemplate.add(pannel);
      pannel.add(
        make(go.Shape, "Circle", [
          {
            fill: "green",
            width: 80,
            height: 80
          }
        ])
      );
      pannel.add(
        make(go.TextBlock, "", [
          {
            // flip: go.GraphObject.FlipHorizontal,
            editable: true,
            // stroke: "white",
            wrap: true
          },
          new Binding("text", "Name").makeTwoWay()
        ])
      );
    }
  }

  @Watch("data")
  private observeData() {
    if (this.diagram && this.data.length > 0) {
      let model = this.diagram.model as go.TreeModel;
      model.nodeDataArray = this.data;
    }
  }

  // render(h:CreateElement) {
  //   h("div",{},[
  //     "this is "+this
  //   ]);
  // }

  private test() {
    // let x = () => import(/* webpackChunkName: "group-foo" */ './Foo.vue');
    // require.ensure()
    // require()
    // Vue.component("", () => {
    // });
    // import("@/components/ghBusinessTree/ghBusinessTree.vue").then(res => {
    //   console.log(res);
    // });
    // console.log(mdiAccount);
  }

  // private nodeTemplate: go.Part = make(
  //   go.Node,
  //   "Auto",
  //   [
  //     {
  //       click: (e, node) => {
  //         let diagram: go.Diagram = node.diagram as go.Diagram;
  //         console.log(node);
  //       }
  //     },
  //     new go.Binding("location", "loc", go.Point.parse).makeTwoWay(
  //       go.Point.stringify
  //     )
  //     // new go.Binding("key", "Id"),
  //     // new go.Binding("parent", "ParentId")
  //   ],
  //   make(
  //     go.Panel,
  //     go.Panel.Auto,
  //     {},

  //     make(go.Shape, "Circle", { fill: "green" }),
  //     make(go.Shape, {
  //       margin: 3,
  //       strokeWidth: 0,
  //       geometry: go.Geometry.parse(
  //         "M9.5 19c0 3.59 2.91 6.5 6.5 6.5s6.5-2.91 6.5-6.5-2.91-6.5-6.5-6.5-6.5 2.91-6.5 6.5zM30 8h-7c-0.5-2-1-4-3-4h-8c-2 0-2.5 2-3 4h-7c-1.1 0-2 0.9-2 2v18c0 1.1 0.9 2 2 2h28c1.1 0 2-0.9 2-2v-18c0-1.1-0.9-2-2-2zM16 27.875c-4.902 0-8.875-3.973-8.875-8.875s3.973-8.875 8.875-8.875c4.902 0 8.875 3.973 8.875 8.875s-3.973 8.875-8.875 8.875zM30 14h-4v-2h4v2z",
  //         true
  //       )
  //     }),
  //     make(go.TextBlock, {}, new go.Binding("text", "Name"))
  //   )
  // );

  // private linkTemplate: go.Part = make(
  //   go.Link,
  //   go.Link.Orthogonal,
  //   { corner: 5, relinkableFrom: true, relinkableTo: true },
  //   make(go.Shape, { strokeWidth: 4, stroke: "#00a4a4" })
  // );

  // private test() {
  //   let x = get("/mdi-account").then(res => {
  //     console.log(x);
  //   });
  //   // console.log(this.$vuetify.icons);
  // }
}
